import { Flex, Spinner, VStack } from '@chakra-ui/react'
import TimelineEvent from './TimelineEvent'
import TimelineDivider from './TimelineDivider'
import { Assessment } from 'interfaces/assessment'

interface Props {
	assessments: Assessment[]
	isLoading: boolean
}

const Timeline = ({ assessments, isLoading }: Props) => {

    if(isLoading)
        return (
            <Flex w="full" justifyContent="center" py={4}>
                <Spinner size="lg" />
            </Flex>
        )

	return (
		<VStack divider={<TimelineDivider />}>
			{
				assessments.map((asm) => <TimelineEvent assessment={asm} />)
			}
		</VStack>
	)
}

export default Timeline
